import { AdministerMedsUIConfig } from "../components/ui/AdministerMedsUI";
import { ArtifitialProgressUIConfig } from "../components/ui/ArtifitialProgressUI";
import { BVMAttemptChooseHandUIConfig } from "../components/ui/BVMAttemptChooseHandUI";
import { DialogUIConfig } from "../components/ui/DialogUI";
import { ETTSizeUIConfig } from "../components/ui/ETTSizeUI";
import { HUDUIConfig } from "../components/ui/hud/HUDUI";
import { BVMMakeAttemptUIConfig } from "../components/ui/BVMMakeAttemptUI";
import { NotificationUIConfig } from "../components/ui/NotificationUI";
import { SBARUIConfig } from "../components/ui/SBARUI";
import { ToolbagUIConfig } from "../components/ui/ToolbagUI";
import GameManager from "../cvp-webgames-core/GameManager";
import BaseScenario from "../cvp-webgames-core/Scenario/BaseScenario";
import { constants } from "../misc/constants";
import { ETTMakeAttemptUIConfig } from "../components/ui/ETTMakeAttemptUI";
import { SGAMakeAttemptUIConfig } from "../components/ui/SGAMakeAttemptUI";
import { AuscultateUIConfig } from "../components/ui/AuscultateUI";
import { FloatingMessagesUIConfig } from "../components/ui/FloatingMessagesUI";
import { VortexJobAidUIConfig } from "../components/ui/VortexJobAidUI";
import { GeneralAlertUIConfig } from "../components/ui/GeneralAlertUI";
import { AssessAirwayActionData, AssessAirwayUIConfig } from "../components/ui/AssessAirwayUI";
import { OptionsUIConfig } from "../components/ui/OptionsUI";
import { BVMOptimizationsUIConfig } from "../components/ui/BVMOptimizationsUI";
import { ETTOptimizationsUIConfig } from "../components/ui/ETTOptimizationsUI";
import { SGAOptimizationsUIConfig } from "../components/ui/SGAOptimizationsUI";
import { PalpateNeckUIConfig } from "../components/ui/PalpateNeckUI";
import { CricMakeAttemptUIConfig } from "../components/ui/CricMakeAttemptUI";
import { DebriefIntro, DebriefUIConfig, DebriefVortex } from "../components/ui/DebriefUI";
import { SideMenuUIConfig } from "../components/ui/side-menu/SideMenu";
import { PreOxygenateOptionsUIConfig } from "../components/ui/PreOxygenateOptionsUI";
import { DraggedSingleData, DragToolsUIConfig } from "../components/ui/DragToolsUI";
import { ScalpelUIConfig } from "../components/ui/ScalpelUI";
import { InsertionAngleUIConfig } from "../components/ui/InsertionAngleUI";
import { EttOptionsUIConfig } from "../components/ui/EttOptionsUI";
import { forceRerenderUI as forceRerenderUI, getSaveData, saveGame, setFocus, setUp508, Windows } from "../misc/tools";
import { EttSpecialUIConfig } from "../components/ui/EttSpecialUI";
import { ETTInstrumentInsertionUIConfig } from "../components/ui/ETTInstrumentInsertionUI";
import { SuccessType } from "./general/general-scenario-stuff";
import { SuccessFailedAttemptUIConfig } from "../components/ui/SuccessFailedAttemptUI";
import { TriangulatedPoints3D } from "@arction/lcjs";
import { isContext } from "vm";
import { VortexUIConfig, VortexUICurrentAttempt } from "../components/ui/hud/VortexUI";
import { ETTResistanceUIConfig } from "../components/ui/ETTResistanceUI";
import { ScenariosConfig } from "../misc/interfaces";
import { SummativeSlot } from "../pages/MainMenu";
import Tools from "../cvp-webgames-core/Misc/Tools";

export enum Window508Type {
	MuteControls,
    Sbar,
    Main,
    GeneralAlert,
    MonitorSingleButton,
    Toolbag,
    Monitor,
    ArtifitialProgress,
    Notification,
    AssessPatient,
    PreOxygenateOptions,
    AdministerMeds,
    BVMMakeAttempt,
    BVMChooseHandUI,
    AuscultateUI,
    Auscultate,
    SuccessFailedAttempt,
    BVMOptimizations,
    ETTSize,
    ETTMakeAttempt,
    ETTOptions,
    ETTSpecialUI,
    ETTOptimizationsUI,
    ETTInsjtrumentInsertion,
    SGAMakeAttempt,
    SGAOptimizationsUI,
    CricPalpateUI,
    CricMakeAttemptUI,
    CricScalpelUI,
    CricInsertionAngle,
    debriefUI,
    VortexJobAid
}

var current508Window = Window508Type.MuteControls;
var currentMainWindow = Window508Type.Main;
var windows508Layers: any[] = []

const objectWindowIDs = {
    muteControls: {
        objects: [] as any
        // objects: [
        //     'cc-bttn',
        //     'mute-bttn'
        // ]
    },
    sbar: {
        objects: [
            'sbar-root',
            'sbar-close-bttn',
        ]
    },
    main: {
        objects: [
            'hud-logo-root',
            'call-for-vortex-button',
        ]
    },
    generalAlert: {
        objects: [
            'general-alert-header',
            'general-alert-button',
        ]
    },
    toolbag: {
        objects: [
            'toolbag-header',
            'toolbag-done-button',
        ]
    },
    monitor: {
        objects: [
            'monitor-ui-root',
            'monitor-ui-close-bttn',
        ]
    },
    artifitialProgress: {
        objects: [
            'artifitial-progress-root',
            'artifitial-progress-root',
        ]
    },
    notification: {
        objects: [
            'notification-root',
            // 'notification-root',
        ]
    },
    assessPatient: {
        objects: [
            'assess-patient-root',
            'assess-patient-done',
        ]
    },
    preOxygenateOptions: {
        objects: [
            'pre-oxygenate-header',
            'pre-oxygenate-done',
        ]
    },
    AdministerMeds: {
        objects: [
            'administer-meds-header',
            'administer-meds-done',
        ]
    },
    BVMMakeAttempt: {
        objects: [] as any

        // objects: [
        //     'bvm-make-attempt-header',
        //     'bvm-make-attempt-abort',
        // ]
    },
    BVMChooseHand: {
        objects: [
            'bvm-choose-hand-header',
            'bvm-choose-hand-next',
        ]
    },
    AuscultateUI: {
        objects: [
            'auscultate-ui-top',
            'auscultate-ui-bottom',
        ]
    },
    Auscultate: {
        objects: [
            'auscultate-top',
            'auscultate-bottom',
        ]
    },
    SuccessFailedAttempt: {
        objects: [
            'success-failed-attempt-top',
            'success-failed-attempt-bottom',
        ]
    },
    BVMOptimizations: {
        objects: [
            'bvm-optimizations-top',
            'bvm-optimizations-bottom',
        ]
    },
    ETTSize: {
        objects: [
            'ett-size-top',
            'ett-size-bottom',
        ]
    },
    ETTMakeAttempt: {
        objects: [
            'ett-make-attempt-top',
            'ett-make-attempt-bottom',
        ]
    },
    ETTOptions: {
        objects: [
            'ett-options-top',
            'ett-options-bottom',
        ]
    },

    ETTSpecialUI: {
        objects: [
            'ett-special-ui-top',
            'ett-special-ui-bottom',
        ]
    },

    ETTOptimizationsUI: {
        objects: [
            'ett-optimizations-ui-top',
            'ett-optimizations-ui-bottom',
        ]
    },

    ETTInstrumentInsertionUI: {
        objects: [
            'ett-instrument-insertion-ui-top',
            'ett-instrument-insertion-ui-bottom',
        ]
    },

    SGAMakeAttemptUI: {
        objects: [
            'sga-make-attempt-ui-top',
            'sga-make-attempt-ui-bottom',
        ]
    },

    SGAOptimizationsUI: {
        objects: [
            'sga-optimizations-ui-top',
            'sga-optimizations-ui-bottom',
        ]
    },

    CricPalpateUI: {
        objects: [
            'cric-palpate-ui-top',
            'cric-palpate-ui-bottom',
        ]
    },

    CricMakeAttemptUI: {
        objects: [
            'cric-make-attempt-ui-top',
            'cric-make-attempt-ui-bottom',
        ]
    },

    CricScalpelUI: {
        objects: [
            'cric-scalpel-ui-top',
            'cric-scalpel-ui-bottom',
        ]
    },

    CricInsertionAngle: {
        objects: [
            'cric-insertion-angle-ui-top',
            'cric-insertion-angle-ui-bottom',
        ]
    },

    DebriefUI: {
        objects: [
            'debrief-ui-top',
            'debrief-ui-bottom',
        ]
    },

    VortexJobAidUI: {
        objects: [
            'VortexJobAidUI-ui-top',
            'VortexJobAidUI-ui-bottom',
        ]
    },
}

const setUpScenario508 = () => {
    windows508Layers[Window508Type.MuteControls] = {
        objects: objectWindowIDs.muteControls.objects
    };

    windows508Layers[Window508Type.Sbar] = {
        objects: objectWindowIDs.sbar.objects
    };

    windows508Layers[Window508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };

    windows508Layers[Window508Type.GeneralAlert] = {
        objects: objectWindowIDs.generalAlert.objects
    };

    windows508Layers[Window508Type.Toolbag] = {
        objects: objectWindowIDs.toolbag.objects
    };

    windows508Layers[Window508Type.Monitor] = {
        objects: objectWindowIDs.monitor.objects
    };

    windows508Layers[Window508Type.ArtifitialProgress] = {
        objects: objectWindowIDs.artifitialProgress.objects
    };

    windows508Layers[Window508Type.Notification] = {
        objects: objectWindowIDs.notification.objects
    };

    windows508Layers[Window508Type.AssessPatient] = {
        objects: objectWindowIDs.assessPatient.objects
    };

    windows508Layers[Window508Type.PreOxygenateOptions] = {
        objects: objectWindowIDs.preOxygenateOptions.objects
    };

    windows508Layers[Window508Type.AdministerMeds] = {
        objects: objectWindowIDs.AdministerMeds.objects
    };
    
    windows508Layers[Window508Type.BVMMakeAttempt] = {
        objects: objectWindowIDs.BVMMakeAttempt.objects
    };

    windows508Layers[Window508Type.BVMChooseHandUI] = {
        objects: objectWindowIDs.BVMChooseHand.objects
    };

    windows508Layers[Window508Type.AuscultateUI] = {
        objects: objectWindowIDs.AuscultateUI.objects
    };
    
    windows508Layers[Window508Type.Auscultate] = {
        objects: objectWindowIDs.Auscultate.objects
    };

    windows508Layers[Window508Type.SuccessFailedAttempt] = {
        objects: objectWindowIDs.SuccessFailedAttempt.objects
    };

    windows508Layers[Window508Type.BVMOptimizations] = {
        objects: objectWindowIDs.BVMOptimizations.objects
    };

    windows508Layers[Window508Type.ETTSize] = {
        objects: objectWindowIDs.ETTSize.objects
    };

    windows508Layers[Window508Type.ETTMakeAttempt] = {
        objects: objectWindowIDs.ETTMakeAttempt.objects
    };

    windows508Layers[Window508Type.ETTOptions] = {
        objects: objectWindowIDs.ETTOptions.objects
    };

    windows508Layers[Window508Type.ETTSpecialUI] = {
        objects: objectWindowIDs.ETTSpecialUI.objects
    };

    windows508Layers[Window508Type.ETTOptimizationsUI] = {
        objects: objectWindowIDs.ETTOptimizationsUI.objects
    };

    windows508Layers[Window508Type.ETTInsjtrumentInsertion] = {
        objects: objectWindowIDs.ETTInstrumentInsertionUI.objects
    };

    windows508Layers[Window508Type.SGAMakeAttempt] = {
        objects: objectWindowIDs.SGAMakeAttemptUI.objects
    };

    windows508Layers[Window508Type.SGAOptimizationsUI] = {
        objects: objectWindowIDs.SGAOptimizationsUI.objects
    };

    windows508Layers[Window508Type.CricPalpateUI] = {
        objects: objectWindowIDs.CricPalpateUI.objects
    };

    windows508Layers[Window508Type.CricMakeAttemptUI] = {
        objects: objectWindowIDs.CricMakeAttemptUI.objects
    };

    windows508Layers[Window508Type.CricScalpelUI] = {
        objects: objectWindowIDs.CricScalpelUI.objects
    };

    windows508Layers[Window508Type.CricInsertionAngle] = {
        objects: objectWindowIDs.CricInsertionAngle.objects
    };

    windows508Layers[Window508Type.debriefUI] = {
        objects: objectWindowIDs.DebriefUI.objects
    };

    windows508Layers[Window508Type.VortexJobAid] = {
        objects: objectWindowIDs.VortexJobAidUI.objects
    };
}

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

const set508Window = (window: Window508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}

export enum DebriefScenarioLocation {
    BeforeMeds,
    AfterMeds
}
setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

set508Window(Window508Type.MuteControls);

export class DaarcBaseScenario extends BaseScenario {
	public isEmanuelMcKenzie: boolean = false;
    public uiWrapper = new UIWrapper(this);
    private _totalScore: number = 0;
    public vortexCalled: boolean;
	public currentTaskMessage: string = '';
    private currentDebriefLocation: DebriefScenarioLocation = DebriefScenarioLocation.BeforeMeds;
    private _debriefPriorToMeds: string[] = [];
    private _debriefAfterMeds: string[] = [];
    private _debriefFailedItems: string[] = []
    private _debriefAdminesteringText: string = '';
    public hasInductionTimerRanOut: boolean;
	public vortexPoints: number = 1000;
	public arrangeEquipmentPoints: number = 1000;
	public assessPatientSingleItemPoints: number = 200;
	public arrangeEquipmentBriefTeamPoints: number = 1000;
	public preOxygenatePoints: number = 10000;
	public setSuctionPoints: number = 1000;
	public adjustBedHeightPoints: number = 500;
	public defaultAssessAirwayPoints: number = 200;
	public administermedsPoints: number = 500;
    public isTestScenario: boolean = false;
	public isDebug: boolean = false;

	public arrangeCricToolsPoints: number = 200;
	public cricPalpateNeckPoints: number = 200;
	public cricMakeIncisionPoints: number = 200;
	public cricRemoveScalpelPoints: number = 100;
	public cricInsertSpreaderPoints: number = 100;
	public cricInsertBougiePoints: number = 200;
	public cricEttPoints: number = 200;
	public cricEtTubeCuffPoints: number = 200;
	public cricAmbuBagSqueeze: number = 32700;

    public bvmOneHandedUIPoints: number = 2000;

    public ettInstrumentForInsertionPoints: number = 2000;

    public bvmAttemptCount: number = 0; //track during scenario for debrief vortex count
    public ettAttemptCount: number = 0; //track during scenario for debrief vortex count
    public sgaAttemptCount: number = 0; //track during scenario for debrief vortex count
    public cricAttemptCount: number = 0; //track during scenario for debrief vortex count
    public addText: string = ''; // setting additional, important text for scenario end purposes
    public preOxDone: boolean = false;
    public callFlexBr: boolean = false;
    
    public updateMain508Window(window: Window508Type) {
        currentMainWindow = window;
    }

    public update508Window(window: Window508Type) {
        set508Window(window);
    }

    public get isLite(): boolean {
        return constants.isLite;
    } 

    public get apneaTimeElapsed(): string {
        return this.apneaTimeMinutesElapsed + ':' + this.apneaTimeSecondsElapsed;
    } 

    public get apneaTimeMinutesElapsed(): string {
        return (window as any)['apneaTimeMinutes'];
    } 

    public get apneaTimeSecondsElapsed(): string {
        return (window as any)['apneaTimeSeconds'];
    } 

    public _id_myNum: number; // scenario number << EVERY SCENARIO MUST SET THIS VARIABLE <<
    public _id_vidBase: string = 'DAARC - Scenario'; // _id_vidBase = {string} + _id_myNum    
   
    public _id_bedPos: string = ' - Flat -'; // changes to 45 with bed adjustment
    public _id_bedAdj: string = ' - 45 -'; // update bedPosUrl to this in part 4 config's "onAdjustedBedHeight"

    public _id_ettAttempt: string = ' ETT -'; 
    public _id_sgaAttempt: string = ' SGA -';

    // Default texts will get updated if pre-ox is performed
    public _id_bvmAusc: string = ' bvm-auscultate-no-pre-oxy - 25';
    public _id_ettAusc: string = ' ett-auscultate-no-pre-oxy - 28';
    public _id_sgaAusc: string = ' sga-auscultate-no-pre-oxy - 31';
    public _id_cricAusc: string = ' cric-auscultate-no-pre-oxy - 34';
    public _id_preOxText: string = ' Nothing - 7'; // default

    public _id_bvmHandAttempt: string; //updates with hand selection

    public _id_updateIdleAfterAttempt: string = '';

    public _id_ScenarioSet(myScenarioNumber: number){
        this._id_myNum = myScenarioNumber; // saving in case needed later
    }

    public _id_SegmentContext(bedPosOverride?: boolean): string {
        // the first portion of the segment id remains uniform through the bed position
        if(bedPosOverride) { // must supply own bed position
            return this._id_vidBase + 
            this._id_myNum 
        }

        return this._id_vidBase + 
        this._id_myNum +
        this._id_bedPos
    }    

    public _id_UpdatePreOxText(selection: number) { // <----------- ADD CRIC AUSC MESSAGES
        switch(selection) {
            case 0:
                this._id_preOxText = ' cannula - 9';
                this._id_bvmAusc = ' bvm-auscultate-nasalcannula - 27';
                this._id_ettAusc = ' ett-auscultate-nasalcannula - 30'
                this._id_sgaAusc = ' sga-auscultate-nasalcannula - 33'
                // THIS._ID_CRICAUSC = ' STRING ' 
                break;
            case 1:
                this._id_preOxText = ' CPAP - 10';
                this._id_bvmAusc = ' bvm-auscultate-cpap - 26';
                this._id_ettAusc = ' ett-auscultate-cpap - 29'
                this._id_sgaAusc = ' sga-auscultate-cpap - 32'
                // THIS._ID_CRICAUSC = ' STRING ' 
                break;
            case 2:
                this._id_preOxText = ' Rebreather - 11';                
                break;
            case 3:
                this._id_preOxText = ' BVM - RT Squeezing - 12';
                break;
        }
    }

    public _id_BVMAttempt(hands: number): string {
        this._id_updateIdleAfterAttempt = 'bvm';
        switch(hands){
            case 1:
                if(this._id_preOxText === ' Nothing - 7') {
                    return ' bvm-attempt-onehanded-no-pre-oxy - 39'
                } else if(this._id_preOxText === ' cannula - 9') {
                    return ' bvm-attempt-onehanded-no-pre-oxy - 39'
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' bvm-attempt-onehanded-no-pre-oxy - 39'
                } else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' bvm-attempt-onehanded-no-pre-oxy - 39'
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' bvm-attempt-onehanded-no-pre-oxy - 39'
                }
            case 2:
                if(this._id_preOxText === ' Nothing - 7') {
                    return ' bvm-attempt-twohanded-no-pre-oxy - 38'
                } else if(this._id_preOxText === ' cannula - 9') {
                    return ' bvm-attempt-twohanded-no-pre-oxy - 38'
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' bvm-attempt-twohanded-no-pre-oxy - 38'
                } else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' bvm-attempt-twohanded-no-pre-oxy - 38'
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' bvm-attempt-twohanded-no-pre-oxy - 38'
                }
        }
    }

    public _id_ETTAttempt(): string {
        this._id_updateIdleAfterAttempt = 'ett';
        //  text & numbers vary depending on bed pos
        if(this._id_bedPos != this._id_bedAdj){ //bed is flat
            if(this._id_preOxText === ' cannula - 9') {
                return ' ett-cannula - 49'
            } else if(this._id_preOxText === ' CPAP - 10') {
                return ' ett-cpap - 48'
            } else if(this._id_preOxText === ' Nothing - 7') {
                return ' ett-nothing - 47'
            }  else if(this._id_preOxText === ' Rebreather - 11') {
                return ' ett-nothing - 47'
            } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                return ' ett-nothing - 47'
            }
        } else { // bed is 45 (adjusted)
            if(this._id_preOxText === ' cannula - 9') {
                return ' ett-cannula - 49'
            } else if(this._id_preOxText === ' CPAP - 10') {
                return ' ett-cpap - 48'
            } else if(this._id_preOxText === ' Nothing - 7') {
                return ' ett-nothing - 47'
            }  else if(this._id_preOxText === ' Rebreather - 11') {
                return ' ett-nothing - 47'
            } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                return ' ett-nothing - 47'
            }
        }
    }

    public _id_SGAAttempt(): string {              
        this._id_updateIdleAfterAttempt = 'sga';
        if(this._id_preOxText === ' cannula - 9') {
            return ' sga-cannula - 52'
        } else if(this._id_preOxText === ' CPAP - 10') {
            return ' sga-cpap - 51'
        } else if(this._id_preOxText === ' Nothing - 7') {
            return ' sga-nothing - 50'
        }  else if(this._id_preOxText === ' Rebreather - 11') {
            return ' sga-nothing - 50'
        } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
            return ' sga-nothing - 50'
        }        
    }

    public _id_CricPart(part: number): string {
        this._id_updateIdleAfterAttempt = 'cric';
        switch(part) {
            case 1:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric-part1-landmarks - 19' // <<< CANULA / CRIC STEP 1 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric-part1-landmarks - 19' // <<< CPAP / CRIC STEP 1 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric-part1-landmarks - 19' // <<< NONE / CRIC STEP 1 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric-part1-landmarks - 19' // <<< NONE / CRIC STEP 1 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric-part1-landmarks - 19' // <<< NONE / CRIC STEP 1 STRING
                }  
                //return ' cric-part1-landmarks - 19' 
            case 2:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric-part2-scalpel - 20' // <<< CANULA / CRIC STEP 2 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric-part2-scalpel - 20' // <<< CPAP / CRIC STEP 2 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric-part2-scalpel - 20' // <<< NONE / CRIC STEP 2 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric-part2-scalpel - 20' // <<< NONE / CRIC STEP 2 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric-part2-scalpel - 20' // <<< NONE / CRIC STEP 2 STRING
                }
                //return ' cric-part2-scalpel - 20'
            case 3:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric-part3-spreader - 21' // <<< CANULA / CRIC STEP 3 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric-part3-spreader - 21' // <<< CPAP / CRIC STEP 3 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric-part3-spreader - 21' // <<< NONE / CRIC STEP 3 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric-part3-spreader - 21' // <<< NONE / CRIC STEP 3 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric-part3-spreader - 21' // <<< NONE / CRIC STEP 3 STRING
                }
                //return ' cric-part3-spreader - 21'
            case 4:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric-part4-bougie - 22' // <<< CANULA / CRIC STEP 4 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric-part4-bougie - 22' // <<< CPAP / CRIC STEP 4 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric-part4-bougie - 22' // <<< NONE / CRIC STEP 4 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric-part4-bougie - 22' // <<< NONE / CRIC STEP 4 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric-part4-bougie - 22' // <<< NONE / CRIC STEP 4 STRING
                }
                //return ' cric-part4-bougie - 22'
            case 5:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric-part5-ett - 23' // <<< CANULA / CRIC STEP 5 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric-part5-ett - 23' // <<< CPAP / CRIC STEP 5 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric-part5-ett - 23' // <<< NONE / CRIC STEP 5 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric-part5-ett - 23' // <<< NONE / CRIC STEP 5 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric-part5-ett - 23' // <<< NONE / CRIC STEP 5 STRING
                }
                //return ' cric-part5-ett - 23'
            case 6:
                if(this._id_preOxText === ' cannula - 9') {
                    return ' cric - cannula - 5' // <<< CANULA / CRIC STEP 6 STRING
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return ' cric - CPAP - 6' // <<< CPAP / CRIC STEP 6 STRING
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return ' cric - No PreOx - 4' // <<< NONE / CRIC STEP 6 STRING
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return ' cric - No PreOx - 4' // <<< NONE / CRIC STEP 6 STRING
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return ' cric - No PreOx - 4' // <<< NONE / CRIC STEP 6 STRING
                }
                //return ' cric-part6-syringe - 24'
        }  
    }

    public _id_SegmentAssembly(input: string, bedPosOR?: string) {
        var temp: string;
        if(bedPosOR === 'flat') { // return true to not receive bed Pos
            return this._id_SegmentContext(true) + ' - flat -' + input
        } else if(bedPosOR === '45') {
            return this._id_SegmentContext(true) + ' - 45 -' + input
        } else if(bedPosOR === 'Flat') {  // capital F
            return this._id_SegmentContext(true) + ' - Flat -' + input
        }
        
        return this._id_SegmentContext() + input;
    }

    public _id_UpdatedNeutralLoop() { // This logic will return the full segment ID string for the desired video to play after an unsuccessful attempt has been made, and closes the optimizations modal, selecting to try something else
        switch(this._id_updateIdleAfterAttempt) {
            case 'bvm': // there are no pre-ox variables while RT is doing BVM, all return the same
                if(this._id_preOxText === ' cannula - 9') {
                    return this._id_SegmentContext(true) + ' - 45 -' + ' BVM - RT Squeezing - 12'
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' BVM - RT Squeezing - 12'
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' BVM - RT Squeezing - 12'
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' BVM - RT Squeezing - 12'
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' BVM - RT Squeezing - 12'
                }
            case 'ett':
                if(this._id_preOxText === ' cannula - 9') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' ETT - cannula - 14'
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' ETT - CPAP - 15'
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' ETT - No PreOx - 13'
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' ETT - No PreOx - 13'
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' ETT - No PreOx - 13'
                }
            case 'sga':
                if(this._id_preOxText === ' cannula - 9') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' SGA - cannula - 17'
                } else if(this._id_preOxText === ' CPAP - 10') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' SGA - CPAP - 18'
                } else if(this._id_preOxText === ' Nothing - 7') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' SGA - No PreOx - 16'
                }  else if(this._id_preOxText === ' Rebreather - 11') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' SGA - No PreOx - 16'
                } else if(this._id_preOxText === ' BVM - RT Squeezing - 12') {
                    return this._id_SegmentContext(true) + ' - 45 -' +  ' SGA - No PreOx - 16'
            }
            case '':
                return this._id_SegmentAssembly(this._id_preOxText); //failsafe, should not occur
        }
    }

    public auscultateAudio: string;
    public auscSuccess: string = 'The patient\'s chest is rising and falling, and there is humidification.';
    public auscFailed: string = 'There is no rise and fall of the patient\'s chest, and there is no humidification.';
    public auscText: string = 'There is no rise and fall of the patient\'s chest, and there is no humidification.';
    public hoverBreathYes: any = [{
        top: '250px',
        left: '450px',
        title: 'Left lung: breath sounds'
    },
    {
        top: '675px',
        left: '450px',
        title: 'Right lung: breath sounds'
    },
    {
        top: '500px',
        left: '1100px',
        title: 'Abdomen: no sound'
    }]
    public hoverBreathNo: any = [{
        top: '250px',
        left: '450px',
        title: 'Left lung: no sound'
    },
    {
        top: '675px',
        left: '450px',
        title: 'Right lung: no sound'
    },
    {
        top: '550px',
        left: '1100px',
        title: 'Abdomen: no sound'
    }]   
    public hoverBreathGurgle: any = [{
        top: '250px',
        left: '450px',
        title: 'Left lung: no sound'
    },
    {
        top: '675px',
        left: '450px',
        title: 'Right lung: no sound'
    },
    {
        top: '550px',
        left: '1100px',
        title: 'Abdomen: gurgling'
    }]  
    
	public hudId: string;
	public vortexId: string;
	public sideMenuId: string;
	public toolbagId: string;
    public assessAirwayId: string;
	public failedScenario: boolean = false;
    public setDebriefScenarioLocation(location: DebriefScenarioLocation) {
        this.currentDebriefLocation = location;
    }

    public debriefLog(text: string) {
        switch(this.currentDebriefLocation) {
            case DebriefScenarioLocation.BeforeMeds:
                this._debriefPriorToMeds.push(text);
                break;
            case DebriefScenarioLocation.AfterMeds:
                this._debriefAfterMeds.push(text);
                break;
        }
    }

    public debriefLogFailedItem(text: string) {
        this._debriefFailedItems.push(text);
    }

    public debriefSetAdministeringText(text: string) {
        this._debriefAdminesteringText = text;
    }

    public reassignMainMenuSlot() {
        const savedData = getSaveData();
        var save = false;
        for(var indx = 0; indx < savedData.scenarios.length; indx++) {
            const scenario = savedData.scenarios[indx];
            if(scenario.scenarioWindow.toString() === this.scenarioName) {
                if(scenario.isSummative) {
                    save = true;
                    savedData.failedSummativeCount++;
                    if(savedData.failedSummativeCount >=3) { // changed from 4 to 3 for gold according to feedback
                        save = false;
                        localStorage.removeItem('saved-game-daarc');
                        localStorage.setItem('show-nuke-popup', 'true');
                        break;
                    }
                    var selectedSummativeScenarioIndex = null;

                    for(var sIndx = 0; sIndx < savedData.selectedSummativeScenarioIndices.length; sIndx++) {
                        var selectedSummativeScenarioData = savedData.selectedSummativeScenarioIndices[sIndx];
                        if(selectedSummativeScenarioData.scenarioNumber === indx) {
                            selectedSummativeScenarioIndex = selectedSummativeScenarioData;
                        }
                    }

                    if(!selectedSummativeScenarioIndex) {
                        return;
                    }

                    switch(selectedSummativeScenarioIndex.slotIndex) {
                        case 0: //first slot of summative can only be item at index 7
                            selectedSummativeScenarioIndex.scenarioNumber = 7
                            break;
                        case 1: //second slot of summative can be any items between indices 9 and 10
                            selectedSummativeScenarioIndex.scenarioNumber = Tools.randomInteger(9, 10)
                            break;
                        case 2: //third slot of summative can only be any item at any of these indices: 4, 6
                            selectedSummativeScenarioIndex.scenarioNumber = Tools.randomInteger(1, 2) === 1 ? 4 : 6
                            break;
                        case 3: //fourth slot of summative can only be any item at any of these indices: 5, 8
                            var choice= Tools.randomInteger(1, 2)
                            switch(choice) {
                                case 1:
                                    selectedSummativeScenarioIndex.scenarioNumber = 5;
                                    break;
                                case 2:
                                    selectedSummativeScenarioIndex.scenarioNumber = 8;
                                    break;
                            }
                            break;
                    }

                    savedData.scenarios[selectedSummativeScenarioIndex.scenarioNumber].isUnlocked = true;
                }
                break;
            }
        }

        if(save) {
            saveGame(savedData);
        }
    }

    public onShowSuccessFailedAttempt(attemptUITitle: string, attemptUIText: string, showDebriefOnClose: boolean, onDone?: () => void, imgUrl?: string) {
        const context = this;
        setTimeout(() => {
            set508Window(Window508Type.SuccessFailedAttempt);
        }, 500);
        if(this.failedScenario) {
            context.uiWrapper.destroyAllUIInstances(true);
            context.reassignMainMenuSlot();
            this.gameManager.customData.dispatch({
                type: 'hideAllUIs'
            });
        }
        context.uiWrapper.displaySuccessFailedAttemptUI({
            title: attemptUITitle,
            text: attemptUIText,
            imgUrl: imgUrl,
            onContinueClicked: () => {
                if(showDebriefOnClose) {
                    context.displayDebrief();
                }

                if(onDone) {
                    onDone();
                }
            }
        })
    }

    public getSummativeScenarioIndexByIndex(savedData: ScenariosConfig) {
        // var sortedArr = [...savedData.selectedSummativeScenarioIndices].sort((a, b) => (a.slotIndex > b.slotIndex) ? 1 : -1)
        for(var indx = 0; indx < savedData.selectedSummativeScenarioIndices.length; indx++) {
            var scenarioIndx = savedData.selectedSummativeScenarioIndices[indx].scenarioNumber;
            if(!savedData.scenarios[scenarioIndx].isCompleted) {
                return savedData.selectedSummativeScenarioIndices[indx];
            }
        }
    }

    public unlockNextScenario() {
        const savedData = getSaveData();

        var finishedAllSummative = false;

        for(var indx = 0; indx < savedData.scenarios.length; indx++) {
            const scenario = savedData.scenarios[indx];
            if(scenario.scenarioWindow.toString() === this.scenarioName) {
                scenario.isCompleted = true;
                savedData.lastScenarioIndexCompleted = indx;
                if(this.isDebug) {
                    scenario.score = 100;
                }
                if(scenario.isSummative || (!scenario.isSummative && savedData.scenarios[indx+1].isSummative)) {
                    if(indx === savedData.selectedSummativeScenarioIndices[savedData.selectedSummativeScenarioIndices.length - 1].scenarioNumber) {
                        finishedAllSummative = true;
                        break;
                    }

                    var nextsummativeIndx = this.getSummativeScenarioIndexByIndex(savedData);

                    if(!nextsummativeIndx) {
                        //just completed all practice scenarios
                        savedData.completedAllPracticeScenarios = true;
                    } else {
                        var sIndx = nextsummativeIndx.scenarioNumber;
                        const nextScenarioSummative = savedData.scenarios[sIndx];
                        nextScenarioSummative.isUnlocked = true;
                    }
                } else {
                    const nextScenario = savedData.scenarios[indx+1];
                    nextScenario.isUnlocked = true;
                }
                break;
            }
        }

        if(finishedAllSummative) {
            savedData.completedAllTestScenarios = true;
        }

        saveGame(savedData);
    }

    public getDebriefIntro() : DebriefIntro  {
        throw new Error('getDebriefIntro must be implemented')
    }

    public getDebriefVortex() : DebriefVortex  {
        throw new Error('getDebriefVortex must be implemented')
    }

    public getAssessAirwayData() : AssessAirwayActionData[]  {
        throw new Error('getAssessAirwayData must be implemented')
    }

    public displayDebrief() {
        const context = this;
        context.uiWrapper.displayDebriefUI({
            intro: context.getDebriefIntro(),
            priorToMedsItems: context._debriefPriorToMeds,
            afterMedsItems: context._debriefAfterMeds,
            failedItems: context._debriefFailedItems,
            administeringMedsTex: context._debriefAdminesteringText,
            vortex: context.getDebriefVortex(),
            isEmanuelMcKenzie: context.isEmanuelMcKenzie,
            onCloseClicked: () => {
                context.gameManager.customData.updateWindow(Windows.MainMenu);
            }
        }) 
    }

    public showDefaultSideMenu() {
		const context = this;
		context.sideMenuId = context.uiWrapper.displaySideMenu({
			gameManager: this.gameManager,
			inductionTimeInSeconds: 800,
			apneaTimeInSeconds: 10,
			bloodPressureNumerator: 102,
			bloodPressureDenominator: 63,
			bloodPressureMinNumerator: 50,
			bloodPressureMinDenominator: 33,
			bloodPressureMaxNumerator: 220,
			bloodPressureMaxDenominator: 110,
			sa02: 100,
			heartRate: 105,
			heartRateMax: 150,
			respirationRate: 22,
			resetEtc02: false,
			etc02: 35,
			showETC02: false,
			isApneaTimerIdle: true,
            onInductionTimerRanOut: () => {
                context.hasInductionTimerRanOut = true;
			},
			onApneaTimerRanOut: () => {
                context.failedScenario = true;
                context.onShowSuccessFailedAttempt(constants.attemptText.failedTitle, constants.attemptText.apneaClockMessage, true);
			}
		}, context.sideMenuId);
	}
    public get predeterminedPoints(): number {
        throw new Error('predeterminedPoints must be implemented');
    }

	public get totalScore(): number {
		return this._totalScore;
	}

    public get maxScore(): number {
        throw new Error('maxScore must be implemented');
	}
    public addScore(score: number) {
		this._totalScore += score;
        this.hudId = this.uiWrapper.displayHUD({
			score: this.totalScore,
			maxScore: this.maxScore
		}, this.hudId);
	}
    public init(onDone: () => void): void {
        this.gameManager.customData.scenario = this;
        onDone();
    }

    public displayMessage(message: string, onOkClicked?: () => void) {
        const context = this;
        context.uiWrapper.displayGeneralAlertUI({
            title: 'Message',
            text: message,
            okButton: {
                title: 'OK',
                onClicked: onOkClicked
            }
        });
    }

    public doSomething(thingToDo: string): () => void {
        const context = this;
        const instanceId = context.uiWrapper.displayArtifitialProgressUI({
            title: thingToDo,
            isDone: false
        });

        setTimeout(() => {
            set508Window(Window508Type.ArtifitialProgress);
        }, 350);


        return () => {
            context.uiWrapper.displayArtifitialProgressUI({
                title: thingToDo,
                isDone: true
            }, instanceId);
            //TODO: remove this once adding animations
            context.uiWrapper.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ArtifitialProgressUI);
            set508Window(Window508Type.Main);
        }
    }

    public shouldLoadScenario(): boolean {
		return false;
	}
    constructor(gameManager: GameManager, public scenarioName: string) {
		super(gameManager, scenarioName);
	}

    public get currentLevel(): number {
        throw new Error('currentLevel must be implemented');
    }

    public showFailedScenario(message: string) {
        this.uiWrapper.displayGeneralAlertUI({
			title: 'Failure on this Scenario',
			text: message,
			okButton: {
				title: 'Debrief',
				onClicked: () => {
					alert('Debrief clicked')
				}
			}
		})
    }
}

export class UIWrapper {
    constructor(private _sceanrio: DaarcBaseScenario) {
    }

    public displaySuccessFailedAttemptUI(config: SuccessFailedAttemptUIConfig): string {
        var oldCallback = config.onContinueClicked;
        var context = this;
        config.onContinueClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.SuccessFailedAttemptUI);
            var data = getSaveData();

            var level = this._sceanrio.currentLevel-1;
            data.scenarios[level].isCompleted = true;
            data.scenarios[level].score = (this._sceanrio.totalScore / this._sceanrio.maxScore) * 100;

            saveGame(data);
            if(oldCallback) {
                oldCallback();
            }
            set508Window(currentMainWindow);
        }; 
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SuccessFailedAttemptUI, config);
        forceRerenderUI(constants.uiNames.SuccessFailedAttemptUI);
        set508Window(Window508Type.SuccessFailedAttempt)
        return res;
    }

    public displayPreOxygenateOptionsUI(config: PreOxygenateOptionsUIConfig): string {
        var oldOnDoneCallback = config.onDoneClicked;
        var context = this;
        config.onDoneClicked = (selection: number) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.PreOxygenateOptionsUI);
            if(oldOnDoneCallback) {
                oldOnDoneCallback(selection);
            }
            set508Window(currentMainWindow);
        }; 
        var oldCloseCallback = config.onCloseClicked;

        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.PreOxygenateOptionsUI);
            if(oldCloseCallback) {
                oldCloseCallback();
            }
            set508Window(currentMainWindow);
        }; 
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.PreOxygenateOptionsUI, config);
        forceRerenderUI(constants.uiNames.PreOxygenateOptionsUI);
        set508Window(Window508Type.PreOxygenateOptions);
        return res;
    }

    public displayPalpitateNeckUI(config: PalpateNeckUIConfig): string {
        var oldCallback = config.onFinished;
        var context = this;
        config.onFinished = (isCorrect: boolean) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.PalpateNeckUI);
            if(oldCallback) {
                oldCallback(isCorrect);
            }
            set508Window(currentMainWindow)
        }; 
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.PalpateNeckUI, config);
        forceRerenderUI(constants.uiNames.PalpateNeckUI);
        set508Window(Window508Type.CricPalpateUI)
        return res;
    }

    public displaySBAR(config: SBARUIConfig): string {
        set508Window(Window508Type.Sbar);

        var oldCallback = config.onClosedClicked;
        var context = this;
        config.onClosedClicked = () => {
            context.destroyAllUIInstances();
            set508Window(currentMainWindow);
            forceRerenderUI(constants.uiNames.SBARUI);
            if(oldCallback) {
                oldCallback();
            }
        }; 
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SBARUI, config);
        forceRerenderUI(constants.uiNames.SBARUI);
        return res;
    }

    public displayHUD(config: HUDUIConfig, instanceId?: string): string {
        if(instanceId) {
            if(this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config)) {
                forceRerenderUI(constants.uiNames.HUDUI, instanceId);
                return instanceId;
            }
        }

        var context = this;
        var oldCallback = config.onExitClicked;
        config.onExitClicked = () => {
            if(oldCallback) {
                oldCallback();
            }

            context._sceanrio.gameManager.customData.updateWindow(Windows.MainMenu);
        };

        (window as any).isDisplayingHud = true;

        if((window as any).forceUpdateInternalCCComp) {
            (window as any).forceUpdateInternalCCComp();
        }

        if((window as any).onForceCCButtonRerender) {
            (window as any).onForceCCButtonRerender();
        }

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.HUDUI, config);
        forceRerenderUI(constants.uiNames.HUDUI);

        this._sceanrio.vortexId = this.displayVortexUI({
            currentAttempt: VortexUICurrentAttempt.None
        }, this._sceanrio.vortexId);
        return res;
    }

    public displayVortexUI(config: VortexUIConfig, instanceId?: string): string {
        if(instanceId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            forceRerenderUI(constants.uiNames.VortexUI, instanceId);
            return instanceId;
        }

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.VortexUI, config);
        forceRerenderUI(constants.uiNames.VortexUI);
        return res;
    }

    public displayDebriefUI(config: DebriefUIConfig): string {
        const onStopBlip = (window as any).onDebriefOpened;

		if(onStopBlip) {
			onStopBlip();
		}

        this._sceanrio.gameManager.SoundManager.stopAllSounds();

        this.destroyAllUIInstances(true);
        
        var context = this;
        var oldCallback = config.onCloseClicked;
        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.DebriefUI);
            if(oldCallback) {
                oldCallback();
            }

            set508Window(currentMainWindow)
        };

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.DebriefUI, config);
        forceRerenderUI(constants.uiNames.DebriefUI);
        setTimeout(() => {
            set508Window(Window508Type.debriefUI)
        }, 300);
        return res;
    }

    public displayBVMOptimizationsUI(config: BVMOptimizationsUIConfig): string {
        var context = this;
        var oldMakeAttemptClicked = config.onMakeAttemptClicked;
        config.onMakeAttemptClicked = (isOneHanded: boolean, isOPA: boolean, isNPA: boolean, isManipulateHeadAndNeck: boolean) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.BVMOptimizationsUI);
            if(oldMakeAttemptClicked) {
                oldMakeAttemptClicked(isOneHanded, isOPA, isNPA, isManipulateHeadAndNeck);
            }

            set508Window(currentMainWindow)
        }; 

        var oldChooseAnotherTechniqueClicked = config.onChooseAnotherTechniqueClicked;
        config.onChooseAnotherTechniqueClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.BVMOptimizationsUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldChooseAnotherTechniqueClicked) {
                oldChooseAnotherTechniqueClicked();
            }
            set508Window(currentMainWindow)
        };

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.BVMOptimizationsUI, config);
        forceRerenderUI(constants.uiNames.BVMOptimizationsUI);

        setTimeout(() => {
            set508Window(Window508Type.BVMOptimizations)
        }, 300);
        return res;
    }

    public displayETTOptimizationsUI(config: ETTOptimizationsUIConfig): string {
        var context = this;
        var oldChangeETTechnique = config.onChangeETTechnique;
        config.onChangeETTechnique = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTOptimizationsUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldChangeETTechnique) {
                oldChangeETTechnique();
            }
            set508Window(currentMainWindow);
        }; 

        var oldChooseAnotherTechniqueClicked = config.onChooseAnotherTechniqueClicked;
        config.onChooseAnotherTechniqueClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTOptimizationsUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldChooseAnotherTechniqueClicked) {
                oldChooseAnotherTechniqueClicked();
            }
            set508Window(currentMainWindow);
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTOptimizationsUI, config);
        forceRerenderUI(constants.uiNames.ETTOptimizationsUI);
        set508Window(Window508Type.ETTOptimizationsUI);
        return res;
    }

    public displaySGAOptimizationsUI(config: SGAOptimizationsUIConfig): string {
        var context = this;
        var oldChangeSGASizeClicked = config.onChangeSGASizeClicked;
        config.onChangeSGASizeClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.SGAOptimizationsUI);
            if(oldChangeSGASizeClicked) {
                oldChangeSGASizeClicked();
            }
            set508Window(currentMainWindow)
        }; 
        
        var oldUpDownManeuverClicked = config.onUpDownManeuverClicked;
        config.onUpDownManeuverClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.SGAOptimizationsUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldUpDownManeuverClicked) {
                oldUpDownManeuverClicked();
            }
            set508Window(currentMainWindow)
        }; 

        var oldChooseAnotherTechniqueClicked = config.onChooseAnotherTechniqueClicked;
        config.onChooseAnotherTechniqueClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.SGAOptimizationsUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldChooseAnotherTechniqueClicked) {
                oldChooseAnotherTechniqueClicked();
            }
            set508Window(currentMainWindow)
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SGAOptimizationsUI, config);
        forceRerenderUI(constants.uiNames.SGAOptimizationsUI);
        set508Window(Window508Type.SGAOptimizationsUI)
        return res;
    }

    public displayOptionsUI(config: OptionsUIConfig): string {
        var oldCallback = config.onCloseClicked;
        var context = this;
        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.OptionsUI);
            if(oldCallback) {
                oldCallback();
            }
        }; 
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.OptionsUI, config);
        forceRerenderUI(constants.uiNames.OptionsUI);
        return res;
    }

    public displayAssessAirwayUI(config: AssessAirwayUIConfig, instanceId?: string): string {
        if(instanceId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            forceRerenderUI(constants.uiNames.AssessAirwayUI, instanceId);
            return instanceId;
        }

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AssessAirwayUI, config);
        forceRerenderUI(constants.uiNames.AssessAirwayUI);
        set508Window(Window508Type.AssessPatient);
        currentMainWindow = Window508Type.AssessPatient;
        return res;
    }

    public displayFloatingMessagesUI(config: FloatingMessagesUIConfig): string {
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.FloatingMessagesUI, config);
        forceRerenderUI(constants.uiNames.FloatingMessagesUI);
        set508Window(Window508Type.Auscultate);
        return res;
    }

    public displayDragToolsUI(config: DragToolsUIConfig, instanceId?: string): string {
        if(instanceId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            forceRerenderUI(constants.uiNames.DraggedToolsUI, instanceId);
            set508Window(currentMainWindow)
            return instanceId;
        }

        var context = this;
        var oldCallback = config.onClose;
        config.onClose = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.DraggedToolsUI);
            if(oldCallback) {
                oldCallback();
            }
            set508Window(currentMainWindow)
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.DraggedToolsUI, config);
        forceRerenderUI(constants.uiNames.DraggedToolsUI);
        set508Window(Window508Type.Toolbag)
        return res;
    }

    public displayToolbag(config: ToolbagUIConfig, instanceId?: string): string {
        var oldCallback = config.onShouldShowOverlay;
        config.onShouldShowOverlay = () => {
            var result = false;
            if(oldCallback) {
                result = oldCallback();
            }
            if(result) {
                set508Window(Window508Type.Toolbag);
            }

            return result;
        };
        setTimeout(() => {
            if((window as any).onForceToolbagRerender) {
                (window as any).onForceToolbagRerender(config);
            }
        }, 0);
        if(instanceId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            forceRerenderUI(constants.uiNames.ToolbagUI, instanceId);
            return instanceId;
        }
            
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ToolbagUI, config);
        forceRerenderUI(constants.uiNames.ToolbagUI);
        return res;
    }

    public displayDialog(config: DialogUIConfig): string {
        var oldCallback = config.onNextClicked;
        var context = this;
        config.onNextClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.DialogUI);
            if(oldCallback) {
                oldCallback();
            }
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.DialogUI, config);
        forceRerenderUI(constants.uiNames.DialogUI);
        return res;
    }

    public displayAuscultateUI(config: AuscultateUIConfig): string {
        var context = this;
        var oldOnPatentAirwayNoClicked = config.onPatentAirwayNoClicked;
        config.onPatentAirwayNoClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.AuscultateUI);
            if(oldOnPatentAirwayNoClicked) {
                oldOnPatentAirwayNoClicked();
            }
            currentMainWindow = Window508Type.Main;
            set508Window(currentMainWindow)
        };
        var oldOnPatentAirwayYesClicked = config.onPatentAirwayYesClicked;
        config.onPatentAirwayYesClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.AuscultateUI);
            if(oldOnPatentAirwayYesClicked) {
                oldOnPatentAirwayYesClicked();
            }
            currentMainWindow = Window508Type.Main;
            set508Window(currentMainWindow)
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AuscultateUI, config);
        forceRerenderUI(constants.uiNames.AuscultateUI);
        currentMainWindow = Window508Type.AuscultateUI;
        set508Window(Window508Type.AuscultateUI)
        return res;
    }

    public displayETTSizeUI(config: ETTSizeUIConfig): string {
        var oldCallback = config.onNextClicked;
        var context = this;
        config.onNextClicked = (sizePicked: string) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTSizeUI);
            if(oldCallback) {
                oldCallback(sizePicked);
            }
            set508Window(currentMainWindow);
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTSizeUI, config);
        forceRerenderUI(constants.uiNames.ETTSizeUI);
        set508Window(Window508Type.ETTSize);
        return res;
    }

    public displayEttOptionsUI(config: EttOptionsUIConfig): string {
        var oldCallback = config.OnNextClicked;
        var context = this;
        config.OnNextClicked = (selectedDepth: number) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTOptionsUI);
            if(oldCallback) {
                oldCallback(selectedDepth);
            }
            set508Window(currentMainWindow);
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTOptionsUI, config);
        forceRerenderUI(constants.uiNames.ETTOptionsUI);
        setTimeout(() => {
            set508Window(Window508Type.ETTOptions);
        }, 300);
        return res;
    }

    public displayEttResistanceUI(config: ETTResistanceUIConfig): string {
        var oldCallback = config.onNextClicked;
        var context = this;
        config.onNextClicked = (selectedDepth: number) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTResistanceUI);
            if(oldCallback) {
                oldCallback(selectedDepth);
            }
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTResistanceUI, config);
        forceRerenderUI(constants.uiNames.ETTResistanceUI);
        return res;
    }

    public displayInsertionAngleUI(config: InsertionAngleUIConfig): string {
        var oldCallback = config.OnNextClicked;
        var context = this;
        config.OnNextClicked = (selectedAngleIndx: number, selectedDepth: number) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.InsertionAngleUI);
            if(oldCallback) {
                oldCallback(selectedAngleIndx, selectedDepth);
            }
            set508Window(currentMainWindow)
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.InsertionAngleUI, config);
        forceRerenderUI(constants.uiNames.InsertionAngleUI);
        setTimeout(() => {
            set508Window(Window508Type.CricInsertionAngle)
        }, 250);
        return res;
    }

    public displayAdministerMedsUI(config: AdministerMedsUIConfig): string {
        var oldAdministerCallback = config.onAdministerClicked;
        var oldCloseCallback = config.onCloseClicked;
        var context = this;
        config.onAdministerClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.AdminsterMedsUI);
            if(oldAdministerCallback) {
                oldAdministerCallback();
            }
            setTimeout(() => {
                var item = document.getElementById('administer-meds-header');

                if(item) {
                    set508Window(Window508Type.AdministerMeds);
                } else {
                    set508Window(currentMainWindow);
                }
            }, 250);
        };

        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.AdminsterMedsUI);
            if(oldCloseCallback) {
                oldCloseCallback();
            }
            set508Window(currentMainWindow);
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AdminsterMedsUI, config);
        forceRerenderUI(constants.uiNames.AdminsterMedsUI);
        set508Window(Window508Type.AdministerMeds);
        return res;
    }

    public displayVortexJobAidUI(config: VortexJobAidUIConfig): string {
        var oldCallback = config.onCloseClicked;
        var context = this;
        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            (window as any)['setPauseApneaTimerState'](false);
            set508Window(Window508Type.Main);

            forceRerenderUI(constants.uiNames.VortexJobAidUI);
            if(oldCallback) {
                oldCallback();
            }
        };
        (window as any)['setPauseApneaTimerState'](true);
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.VortexJobAidUI, config);
        forceRerenderUI(constants.uiNames.VortexJobAidUI);
        set508Window(Window508Type.VortexJobAid);
        return res;
    }

    public displayGeneralAlertUI(config: GeneralAlertUIConfig): string {
        var context = this;
        if(config.cancelbutton) {
            var cancelBttnCallback = config.cancelbutton.onClicked;
            config.cancelbutton.onClicked = () => {
                context.destroyAllUIInstances();
                forceRerenderUI(constants.uiNames.GeneralAlertUI);
                if(cancelBttnCallback) {
                    cancelBttnCallback();
                }
            };
        }
        
        var okBttnCallback = config.okButton.onClicked;
        config.okButton.onClicked = () => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.GeneralAlertUI);
            if(okBttnCallback) {
                okBttnCallback();
            }
        };

        set508Window(Window508Type.GeneralAlert);

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.GeneralAlertUI, config);
        forceRerenderUI(constants.uiNames.GeneralAlertUI);
        return res;
    }

    public displayArtifitialProgressUI(config: ArtifitialProgressUIConfig, instanceId?: string): string {
        if(instanceId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            forceRerenderUI(constants.uiNames.ArtifitialProgressUI, instanceId);
            return instanceId;
        }

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ArtifitialProgressUI, config);
        forceRerenderUI(constants.uiNames.ArtifitialProgressUI);
        return res;
    }

    public displayScalpelUI(config: ScalpelUIConfig): string {
        var oldCallback = config.onKeepScalpelInPlaceClicked;
        var context = this;
        config.onKeepScalpelInPlaceClicked = () => {
            context._sceanrio.uiWrapper.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ScalpelUI);
            if(oldCallback) {
                oldCallback();
            }
            currentMainWindow = Window508Type.Main
            set508Window(currentMainWindow)
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ScalpelUI, config);
        forceRerenderUI(constants.uiNames.ScalpelUI);
        set508Window(Window508Type.CricScalpelUI);
        currentMainWindow = Window508Type.CricScalpelUI
        return res;
    }

    public displayNotificationUI(config: NotificationUIConfig): string {
        var oldCallback = config.onDismissed;
        var context = this;
        var isAdministerMeds = current508Window === Window508Type.AdministerMeds;
        config.onDismissed = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.NotificationUI);
            setTimeout(() => {
                if(oldCallback) {
                    oldCallback();
                }
            }, 1000);

            if(current508Window === Window508Type.Notification) {
                if(isAdministerMeds) {
                    set508Window(Window508Type.AdministerMeds);
                } else {
                    set508Window(currentMainWindow);
                }
            }
            
        };
        var instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.NotificationUI, config);
        forceRerenderUI(constants.uiNames.NotificationUI);
        set508Window(Window508Type.Notification);
        return instanceId
    }

    public displayCricMakeAttemptUI(config: CricMakeAttemptUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldMakeAttemptClicked = config.onMakeAttemptClicked;
        config.onMakeAttemptClicked = (selectedToolIndx: number) => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.CricMakeAttemptUI);
            if(oldMakeAttemptClicked) {
                oldMakeAttemptClicked(selectedToolIndx);
            }
            set508Window(currentMainWindow)
        };
        var oldAbortedClicked = config.onAbortedClicked;
        config.onAbortedClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.CricMakeAttemptUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldAbortedClicked) {
                oldAbortedClicked();
            }
            set508Window(currentMainWindow)
        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.CricMakeAttemptUI, config);
        forceRerenderUI(constants.uiNames.CricMakeAttemptUI);
        setTimeout(() => {
            set508Window(Window508Type.CricMakeAttemptUI)
        }, 500);
        return instanceId
    }

    public displaySideMenu(config: SideMenuUIConfig, instanceId?: string): string {
        if(instanceId) {
            var sideMenu = document.getElementById('side-menu-root-obj');
            if(sideMenu) {
                sideMenu.style.visibility = 'visible';
            }
            this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config);
            return instanceId;
        }
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SideMenuUI, config);
        forceRerenderUI(constants.uiNames.SideMenuUI);
        return res;
    }

    public displayBVMMakeAttemptUI(config: BVMMakeAttemptUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldMakeAttemptClicked = config.onMakeAttemptClicked;
        config.onMakeAttemptClicked = (isNPAClicked: boolean, isOPAClicked: boolean) => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.BVMMakeAttemptUI, instanceId);
            if(oldMakeAttemptClicked) {
                oldMakeAttemptClicked(isNPAClicked, isOPAClicked);
            }
            set508Window(currentMainWindow)
        };
        var oldAbortedClicked = config.onAbortedClicked;
        config.onAbortedClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.BVMMakeAttemptUI, instanceId);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldAbortedClicked) {
                oldAbortedClicked();
            }
            set508Window(currentMainWindow)
        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.BVMMakeAttemptUI, config);
        forceRerenderUI(constants.uiNames.BVMMakeAttemptUI);
        set508Window(Window508Type.BVMMakeAttempt)
        return instanceId
    }

    public displayETTMakeAttemptUI(config: ETTMakeAttemptUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldMakeAttemptClicked = config.onMakeAttemptClicked;
        config.onMakeAttemptClicked = (isDLClicked: boolean, isVLClicked: boolean) => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.ETTMakeAttemptUI);
            if(oldMakeAttemptClicked) {
                oldMakeAttemptClicked(isDLClicked, isVLClicked);
            }
            set508Window(currentMainWindow);
        };
        var oldAbortedClicked = config.onAbortedClicked;
        config.onAbortedClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.ETTMakeAttemptUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldAbortedClicked) {
                oldAbortedClicked();
            }
            set508Window(currentMainWindow);
        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTMakeAttemptUI, config);
        forceRerenderUI(constants.uiNames.ETTMakeAttemptUI);

        setTimeout(() => {
            set508Window(Window508Type.ETTMakeAttempt);
        }, 300);
        return instanceId
    }

    public displayETTSpecialUI(config: EttSpecialUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldNextClicked = config.onNextClicked;
        config.onNextClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.EttSpecialUI);
            if(oldNextClicked) {
                oldNextClicked();
            }
            set508Window(currentMainWindow);

        };

        var oldAbortClicked = config.onAbortClicked;
        config.onAbortClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.EttSpecialUI);
            if(oldAbortClicked) {
                oldAbortClicked();
            }
            set508Window(currentMainWindow);

        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.EttSpecialUI, config);
        forceRerenderUI(constants.uiNames.EttSpecialUI);
        setTimeout(() => {
            set508Window(Window508Type.ETTSpecialUI);
        }, 300);

        return instanceId
    }

    public displayETTInstrumentInsertionUI(config: ETTInstrumentInsertionUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldNextClicked = config.onNextClicked;
        config.onNextClicked = (selectedIndex: number) => {
            context._sceanrio.uiWrapper.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTInstrumentInsertionUI);
            if(oldNextClicked) {
                oldNextClicked(selectedIndex);
            }
            set508Window(currentMainWindow);
        };

        var oldAbortClicked = config.onAbortClicked;
        config.onAbortClicked = () => {
            context._sceanrio.uiWrapper.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.ETTInstrumentInsertionUI);
            if(oldAbortClicked) {
                oldAbortClicked();
            }
            set508Window(currentMainWindow);
        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ETTInstrumentInsertionUI, config);
        forceRerenderUI(constants.uiNames.ETTInstrumentInsertionUI);
        setTimeout(() => {
            set508Window(Window508Type.ETTInsjtrumentInsertion);
        }, 300);
        return instanceId
    }

    public displaySGAMakeAttemptUI(config: SGAMakeAttemptUIConfig): string {
        var context = this;
        var instanceId = '';
        var oldMakeAttemptClicked = config.onMakeAttemptClicked;
        config.onMakeAttemptClicked = (selectedSga: string) => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.SGAMakeAttemptUI);
            if(oldMakeAttemptClicked) {
                oldMakeAttemptClicked(selectedSga);
            }
            set508Window(currentMainWindow)
        };
        var oldAbortedClicked = config.onAbortedClicked;
        config.onAbortedClicked = () => {
            context._sceanrio.gameManager.UiManager.destroyUIInstanceById(instanceId);
            forceRerenderUI(constants.uiNames.SGAMakeAttemptUI);
            context._sceanrio.toolbagId = context._sceanrio.uiWrapper.displayToolbag({
                isDisabled: false
            }, context._sceanrio.toolbagId);
            if(oldAbortedClicked) {
                oldAbortedClicked();
            }
            set508Window(currentMainWindow)
        };
        instanceId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SGAMakeAttemptUI, config);
        forceRerenderUI(constants.uiNames.SGAMakeAttemptUI);
        set508Window(Window508Type.SGAMakeAttempt)
        return instanceId
    }

    public displayBVMAttemptUI(config: BVMAttemptChooseHandUIConfig): string {
        var oldCallback = config.onNextClicked;
        var context = this;
        config.onNextClicked = (isOneHanded: boolean) => {
            context.destroyAllUIInstances();
            forceRerenderUI(constants.uiNames.BVMAttemptUI);
            if(oldCallback) {
                oldCallback(isOneHanded);
            }
            set508Window(currentMainWindow);
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.BVMAttemptUI, config);
        forceRerenderUI(constants.uiNames.BVMAttemptUI);

        setTimeout(() => {
            set508Window(Window508Type.BVMChooseHandUI);
        }, 300);
        return res;
    }

    public destroyAllUIInstances(absolutelyEverySingleUI?: boolean) {
        set508Window(currentMainWindow);
        this._sceanrio.gameManager.UiManager.destroyAllInstances(absolutelyEverySingleUI ? [] :  [constants.uiTags.Hud]);
    }
}